module.exports = __webpack_public_path__ + "static/gozaru_naa-8211977c27c6e9ee0288875f1aa31375.jpg";